import gql from 'graphql-tag';

export default gql`
mutation changeAppGuide(
        $uuid: String!,
        $guideName: String,
        $guideDesc: String,
        $guideImage: String
        ) {
    updateApps(input: {
        uuid: $uuid,
        guideName: $guideName,
        guideDesc: $guideDesc,
        guideImage: $guideImage
    }) {
        uuid
    }
}
`;
